import { FIELDS } from './constants';

const defaultFields = [  
  {
    key: 'Id',
    field: FIELDS.ID,
    title: ' Id',
    label: 'Id',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ItemCategoryType',
    field: FIELDS.ITEM_CATEGORY_TYPE,
    title: ' Item Category Type',
    label: 'ItemCategoryType',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Name',
    field: FIELDS.NAME,
    title: ' Name',
    label: 'Name',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'SyncToken',
    field: FIELDS.SYNC_TOKEN,
    title: ' Sync Token',
    label: 'SyncToken',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'InvStartDate',
    field: FIELDS.INV_START_DATE,
    title: ' Inv Start Date',
    label: 'InvStartDate',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Type',
    field: FIELDS.TYPE,
    title: ' Type',
    label: 'Type',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'QtyOnHand',
    field: FIELDS.QTY_ON_HAND,
    title: ' Qty On Hand',
    label: 'QtyOnHand',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'AssetAccountRefName',
    field: FIELDS.ASSET_ACCOUNT_REF_NAME,
    title: ' Asset Account Ref Name',
    label: 'AssetAccountRefName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'AssetAccountRefValue',
    field: FIELDS.ASSET_ACCOUNT_REF_VALUE,
    title: ' Asset Account Ref Value',
    label: 'AssetAccountRefValue',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Sku',
    field: FIELDS.SKU,
    title: ' Sku',
    label: 'Sku',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'SalesTaxIncluded',
    field: FIELDS.SALES_TAX_INCLUDED,
    title: ' Sales Tax Included',
    label: 'SalesTaxIncluded',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'TrackQtyOnHand',
    field: FIELDS.TRACK_QTY_ON_HAND,
    title: ' Track Qty On Hand',
    label: 'TrackQtyOnHand',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'SalesTaxCodeRefName',
    field: FIELDS.SALES_TAX_CODE_REF_NAME,
    title: ' Sales Tax Code Ref Name',
    label: 'SalesTaxCodeRefName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'SalesTaxCodeRefValue',
    field: FIELDS.SALES_TAX_CODE_REF_VALUE,
    title: ' Sales Tax Code Ref Value',
    label: 'SalesTaxCodeRefValue',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ClassRefName',
    field: FIELDS.CLASS_REF_NAME,
    title: ' Class Ref Name',
    label: 'ClassRefName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ClassRefValue',
    field: FIELDS.CLASS_REF_VALUE,
    title: ' Class Ref Value',
    label: 'ClassRefValue',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'PurchaseTaxIncluded',
    field: FIELDS.PURCHASE_TAX_INCLUDED,
    title: ' Purchase Tax Included',
    label: 'PurchaseTaxIncluded',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Description',
    field: FIELDS.DESCRIPTION,
    title: ' Description',
    label: 'Description',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'AbatementRate',
    field: FIELDS.ABATEMENT_RATE,
    title: ' Abatement Rate',
    label: 'AbatementRate',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ReverseChargeRate',
    field: FIELDS.REVERSE_CHARGE_RATE,
    title: ' Reverse Charge Rate',
    label: 'ReverseChargeRate',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'SubItem',
    field: FIELDS.SUB_ITEM,
    title: ' Sub Item',
    label: 'SubItem',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Taxable',
    field: FIELDS.TAXABLE,
    title: ' Taxable',
    label: 'Taxable',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'UQCDisplayText',
    field: FIELDS.UQCDISPLAY_TEXT,
    title: ' UQCDisplay Text',
    label: 'UQCDisplayText',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ReorderPoint',
    field: FIELDS.REORDER_POINT,
    title: ' Reorder Point',
    label: 'ReorderPoint',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'PurchaseDesc',
    field: FIELDS.PURCHASE_DESC,
    title: ' Purchase Desc',
    label: 'PurchaseDesc',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DateCreated',
    field: FIELDS.DATE_CREATED,
    title: ' Date Created',
    label: 'DateCreated',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DateModified',
    field: FIELDS.DATE_MODIFIED,
    title: ' Date Modified',
    label: 'DateModified',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'PrefVendorRefName',
    field: FIELDS.PREF_VENDOR_REF_NAME,
    title: ' Pref Vendor Ref Name',
    label: 'PrefVendorRefName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'PrefVendorRefValue',
    field: FIELDS.PREF_VENDOR_REF_VALUE,
    title: ' Pref Vendor Ref Value',
    label: 'PrefVendorRefValue',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Active',
    field: FIELDS.ACTIVE,
    title: ' Active',
    label: 'Active',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'UQCId',
    field: FIELDS.UQCID,
    title: ' UQCId',
    label: 'UQCId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'PurchaseTaxCodeRefName',
    field: FIELDS.PURCHASE_TAX_CODE_REF_NAME,
    title: ' Purchase Tax Code Ref Name',
    label: 'PurchaseTaxCodeRefName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'PurchaseTaxCodeRefValue',
    field: FIELDS.PURCHASE_TAX_CODE_REF_VALUE,
    title: ' Purchase Tax Code Ref Value',
    label: 'PurchaseTaxCodeRefValue',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ServiceType',
    field: FIELDS.SERVICE_TYPE,
    title: ' Service Type',
    label: 'ServiceType',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'PurchaseCost',
    field: FIELDS.PURCHASE_COST,
    title: ' Purchase Cost',
    label: 'PurchaseCost',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ParentRefName',
    field: FIELDS.PARENT_REF_NAME,
    title: ' Parent Ref Name',
    label: 'ParentRefName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ParentRefValue',
    field: FIELDS.PARENT_REF_VALUE,
    title: ' Parent Ref Value',
    label: 'ParentRefValue',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'UnitPrice',
    field: FIELDS.UNIT_PRICE,
    title: ' Unit Price',
    label: 'UnitPrice',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'FullyQualifiedName',
    field: FIELDS.FULLY_QUALIFIED_NAME,
    title: ' Fully Qualified Name',
    label: 'FullyQualifiedName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Level',
    field: FIELDS.LEVEL,
    title: ' Level',
    label: 'Level',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'IncomeAccountRefName',
    field: FIELDS.INCOME_ACCOUNT_REF_NAME,
    title: ' Income Account Ref Name',
    label: 'IncomeAccountRefName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'IncomeAccountRefValue',
    field: FIELDS.INCOME_ACCOUNT_REF_VALUE,
    title: ' Income Account Ref Value',
    label: 'IncomeAccountRefValue',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ExpenseAccountRefName',
    field: FIELDS.EXPENSE_ACCOUNT_REF_NAME,
    title: ' Expense Account Ref Name',
    label: 'ExpenseAccountRefName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ExpenseAccountRefValue',
    field: FIELDS.EXPENSE_ACCOUNT_REF_VALUE,
    title: ' Expense Account Ref Value',
    label: 'ExpenseAccountRefValue',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'TaxClassificationRefName',
    field: FIELDS.TAX_CLASSIFICATION_REF_NAME,
    title: ' Tax Classification Ref Name',
    label: 'TaxClassificationRefName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'TaxClassificationRefValue',
    field: FIELDS.TAX_CLASSIFICATION_REF_VALUE,
    title: ' Tax Classification Ref Value',
    label: 'TaxClassificationRefValue',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    title: ' ',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
]

export default defaultFields;
